import { clsx } from 'clsx'
import { type ReactElement, useCallback, type MouseEvent } from 'react'

import { RegulationZone, useTranscendAirGap } from '@lib/hooks/use-transcend-airgap'
import { withPublicImageUrl } from '@lib/utils/cdn'

import { NavLink } from '@components/ui-core/nav-links/nav-link'

import styles from './footer.module.css'

export const privacySettingsText: Record<RegulationZone, string> = {
  [RegulationZone.USA]: 'Your Privacy Choices',
  [RegulationZone.GDPR]: 'Cookies Preferences Center',
  [RegulationZone.Other]: '',
}

const ButtonContent = ({ regulationZone }: { regulationZone: RegulationZone }) => {
  if (regulationZone === RegulationZone.USA) {
    return (
      <>
        <img
          className={styles.privacyChoicesIcon}
          src={withPublicImageUrl('privacy-choices-icon.png')}
          alt="Privacy choices icon"
        />
        {privacySettingsText[regulationZone]}
      </>
    )
  }

  return privacySettingsText[regulationZone]
}

interface FooterPrivacyButtonProps {
  className?: string | undefined
}

export function FooterPrivacyButton(props: FooterPrivacyButtonProps): ReactElement | null {
  const { className } = props
  const { isInitialized, regulationZone } = useTranscendAirGap()

  const onOpenCookieSettings = useCallback(
    async (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()

      try {
        if (isInitialized) {
          await (regulationZone === RegulationZone.USA
            ? window?.transcend?.showConsentManager?.({ viewState: 'CompleteOptionsInverted' })
            : window?.transcend?.showConsentManager?.({ viewState: 'CompleteOptionsToggles' }))
        }
      } catch {}
    },
    [isInitialized, regulationZone],
  )

  if (regulationZone === RegulationZone.Other) {
    return null
  }

  return (
    <NavLink
      className={clsx(className, styles.privacyChoicesNavLink)}
      label={<ButtonContent regulationZone={regulationZone} />}
      onClick={onOpenCookieSettings}
      href="#"
      openIn="sameTab"
    />
  )
}
